/**
 * EnvironmentBadge — dot + label compacto.
 *
 * Mudanca UX pass 1 (Apple/Linear):
 *  - Substitui pill boxy por dot 6px + label uppercase.
 *  - Paleta semantica corrigida: prod = amber (atencao), nao error/critical
 *    (vermelho fica reservado pra erro real do sistema).
 *  - Fundo neutro, sem boxinha colorida.
 */

import { cn } from '@/lib/utils/cn';
import type { AccountEnvironment } from '@/lib/api/types';

const ENV_DOT: Record<AccountEnvironment, string> = {
  prod: 'bg-[color:var(--color-env-prod)]',
  staging: 'bg-[color:var(--color-env-staging)]',
  dev: 'bg-[color:var(--color-env-dev)]',
  sandbox: 'bg-[color:var(--color-env-sandbox)]',
  management: 'bg-[color:var(--color-env-management)]',
};

const ENV_LABEL: Record<AccountEnvironment, string> = {
  prod: 'prod',
  staging: 'staging',
  dev: 'dev',
  sandbox: 'sandbox',
  management: 'management',
};

interface EnvironmentBadgeProps {
  environment: AccountEnvironment;
  className?: string;
  /** Quando true, esconde o label (so dot). Util em listas densas. */
  dotOnly?: boolean;
}

export function EnvironmentBadge({
  environment,
  className,
  dotOnly = false,
}: EnvironmentBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 font-mono text-[0.625rem] uppercase tracking-[0.14em] text-muted',
        className,
      )}
      aria-label={`Ambiente ${ENV_LABEL[environment]}`}
    >
      <span aria-hidden="true" className={cn('h-1.5 w-1.5 rounded-full', ENV_DOT[environment])} />
      {!dotOnly && <span>{ENV_LABEL[environment]}</span>}
    </span>
  );
}
